import { AccountType } from "../constants/domains/accounting/accounts";

export type AccrualLineAccountMode = "invoices" | "bills";

const ACCRUAL_LINE_EXCLUDED_ACCOUNT_TYPES: Record<
    AccrualLineAccountMode,
    AccountType[]
> = {
    bills: [AccountType.income, AccountType.otherIncome],
    invoices: [
        AccountType.cogs,
        AccountType.operatingExpenses,
        AccountType.otherExpenses,
    ],
};

export function getAccrualLineAllowedAccountTypes(
    mode: AccrualLineAccountMode,
): AccountType[] {
    const excludedTypes = ACCRUAL_LINE_EXCLUDED_ACCOUNT_TYPES[mode];
    return Object.values(AccountType).filter(
        (type) => !excludedTypes.includes(type),
    );
}
